/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


export const DEFAULT_REQUEST_HEADERS: HeadersInit = {
    "content-type": "application/json"
};


export default DEFAULT_REQUEST_HEADERS;
